<section class="package-issues" aria-labelledby="package-issues-title">
    <div class="package-issues__header">
        <div class="package-issues__heading">
            <h4 id="package-issues-title"><i class="pi pi-github" aria-hidden="true"></i> {{ t()('github.issues') }}</h4>
            @if (repositoryUrl(); as url) {
            <a class="package-issues__repo" [href]="url" target="_blank" rel="noopener noreferrer" [pTooltip]="t()('github.openOnGitHub')">{{ repository() }} <i class="pi pi-external-link" aria-hidden="true"></i></a>
            }
        </div>
        <div class="package-issues__actions">
            @if (repository()) {
            <p-selectbutton [options]="stateOptions()" [ngModel]="state()" (ngModelChange)="setState($event)" optionLabel="label" optionValue="value" [allowEmpty]="false" size="small" />
            <a class="package-issues__manage" [routerLink]="issuesLink().path" [queryParams]="issuesLink().query">{{ t()('issues.manageInIssues') }} <i class="pi pi-arrow-right" aria-hidden="true"></i></a>
            }
        </div>
    </div>

    @if (errorMessage(); as message) {
    <p-message [severity]="errorSeverity()" class="package-issues__message">
        <span>{{ message }}</span>
        @if (showTenantLink()) {
        <a class="package-issues__link" [routerLink]="tenantSettingsLink()">{{ t()('github.configureInTenant') }}</a>
        } @if (errorCode() !== 'package_repository_missing' && errorCode() !== 'github_not_configured') {
        <p-button [label]="t()('github.retry')" icon="pi pi-refresh" [text]="true" size="small" (onClick)="retry()" />
        }
    </p-message>
    } @else if (loading() && issues().length === 0) {
    <app-loading-skeleton preset="table" [count]="4" [label]="t()('github.issues')" />
    } @else if (issues().length === 0) {
    <app-empty-state icon="pi pi-github" [compact]="true" [title]="t()('github.noIssues').replace('{state}', t()('github.state.' + state()).toLowerCase())" [description]="t()('github.noIssuesDetail').replace('{repo}', repository() ?? '')" />
    } @else {
    <ul class="issue-list" role="list">
        @for (issue of issues(); track issue.number) {
        <li class="issue" [class.issue--closed]="issue.state === 'closed'">
            <i class="issue__state" [class.pi-circle]="issue.state !== 'closed'" [class.pi-check-circle]="issue.state === 'closed'" class="pi" [attr.aria-label]="t()('github.state.' + (issue.state === 'closed' ? 'closed' : 'open'))"></i>
            <div class="issue__body">
                <div class="issue__title-row">
                    <a class="issue__title" [routerLink]="issueLink(issue)">{{ issue.title }}</a>
                    @for (label of visibleLabels(issue); track label.name) {
                    <p-tag class="issue__label" [value]="label.name" [style]="labelStyle(label.color)" [rounded]="true" />
                    }
                </div>
                @if (issue.bodyExcerpt) {
                <p class="issue__excerpt">{{ issue.bodyExcerpt }}</p>
                }
                <div class="issue__meta">
                    <span>#{{ issue.number }}</span>
                    <a class="issue__external" [href]="issue.htmlUrl" target="_blank" rel="noopener noreferrer" [pTooltip]="t()('github.openOnGitHub')"><i class="pi pi-external-link" aria-hidden="true"></i></a>
                    @if (issue.author) {
                    <span>{{ t()('github.by').replace('{user}', issue.author) }}</span>
                    }
                    <span>{{ t()('github.updated').replace('{date}', (issue.updatedUtc | date: 'mediumDate') ?? '') }}</span>
                    @if (issue.commentsCount > 0) {
                    <span><i class="pi pi-comment" aria-hidden="true"></i> {{ t()('github.comments').replace('{n}', '' + issue.commentsCount) }}</span>
                    }
                </div>
            </div>
        </li>
        }
    </ul>
    @if (page() > 1 || hasMore()) {
    <div class="issue-paging">
        <p-button [label]="t()('github.previous')" icon="pi pi-angle-left" [text]="true" size="small" [disabled]="page() <= 1 || loading()" (onClick)="prevPage()" />
        <span class="issue-paging__page">{{ t()('github.page').replace('{page}', '' + page()) }}</span>
        <p-button [label]="t()('github.next')" icon="pi pi-angle-right" iconPos="right" [text]="true" size="small" [disabled]="!hasMore() || loading()" (onClick)="nextPage()" />
    </div>
    } }
</section>
